import { LabelSStyle } from "@components/Typography/TextStyles/LabelS"
import styled, { css } from "styled-components"

export const Item = styled.div<{ active?: boolean }>`
  height: 100%;
  cursor: pointer;
  border: none;
  padding: 0;
  outline: none;
  background: transparent;
  display: flex;
  flex-direction: column;
  text-align: center;
  outline: none;
  align-items: center;
  justify-content: center;
  opacity: 1;
  width: 100%;
  &::selection {
    background: rgba(0, 0, 0, 0);
  }

  ${(p) =>
    p.active &&
    css`
      h4 {
        color: black;
      }

      img {
        opacity: 0.3;
      }
    `}
`

export const Loading = styled.div<{ active?: boolean }>`
  height: 100%;
  pointer-events: none;
  border: none;
  padding: 0;
  outline: none;
  background: transparent;
  display: flex;
  flex-direction: column;
  text-align: center;
  outline: none;
  align-items: center;
  justify-content: center;
  opacity: 1;
  width: 100%;
`

export const Img = styled.img`
  width: 100%;
  opacity: 1;
  max-width: 8rem;
  transition: all 0.3s ease-in-out;
  &::selection {
    background: rgba(0, 0, 0, 0);
  }
`

export const ImgContainer = styled.div`
  position: relative;
  width: 100%;
  &::selection {
    background: rgba(0, 0, 0, 0);
  }
`

export const Label = styled.h4`
  ${LabelSStyle};
  transition: all 0.3s ease-in-out;
  text-transform: lowercase;
  max-width: 7rem;
  color: ${(p) => p.theme.colors.text.light};
  &::selection {
    background: rgba(0, 0, 0, 0);
    color: ${(p) => p.theme.colors.text.light};
  }
`
